const root = `td-regulation/cause/`
const urls = {
  getDetail: root + 'detail',
  getList: root + 'list',
  remove: root + 'remove',
  add: root + 'save',
  detail: root + 'detail',
  update: root + 'update',
  getCauserTree: root + 'getCauserTree'
}

// 获取列表页数据
export const getList = obj => {
  return $http.get(urls.getList, obj)
}
// 删除列表中目标数据
export const remove = obj => {
  let ids = Array.isArray(obj) ? obj.map(z => z.id).join(',') : obj.id
  return $http.post(`${urls.remove}?ids=${ids}`)
}

export const add = obj => {
  return $http.post(urls.add, obj)
}
export const detail = id => {
  return $http.get(urls.detail, { id: id })
}
export const update = obj => {
  return $http.post(urls.update, obj)
}
export const getCauserTree = obj => {
  return $http.get(urls.getCauserTree, obj)
}
export default {
  add,
  update,
  detail,
  getList,
  remove,
  getCauserTree
}
